module.exports = __webpack_public_path__ + "images/kihnu/routes/RIN-PAR-RIN.png";